import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { CustomTranslateLoader } from './custom-translate-loader';
import { ServerTranslateLoader } from './server-translate-loader';

export function createTranslateLoader(httpClient: HttpClient, platform: any) {
  return isPlatformBrowser(platform) ? new CustomTranslateLoader(httpClient) : new ServerTranslateLoader();
}
